import { useMemo } from 'react';

const usePrepareHtml = (value?: string) =>
  useMemo(() => {
    if (!value) {
      return null;
    }
    const codeBlocks: string[] = [];
    return value
      .replace(/<code[\s\S]*?<\/code>/g, (match) => {
        codeBlocks.push(match);
        return 'CODE_BLOCK_PLACEHOLDER';
      })
      .replace(/\sclass="[^"]*"/g, '')
      .replace(/<img([^>]*)>/g, (match, imgTagContent) => {
        const widthMatch = imgTagContent.match(/\swidth="(\d+)"/);
        const width = widthMatch ? parseInt(widthMatch[1], 10) : null;
        if (width && width > 480) {
          return `<img${imgTagContent.replace(/\swidth="[^"]*"|\sheight="[^"]*"/g, '')}>`;
        }
        return match;
      })
      .replace(/<iframe([^>]*)>/g, (match, iframeTagContent) => {
        const widthMatch = iframeTagContent.match(/\swidth="(\d+)"/);
        const heightMatch = iframeTagContent.match(/\sheight="(\d+)"/);
        const width = widthMatch ? parseInt(widthMatch[1], 10) : null;
        const height = heightMatch ? parseInt(heightMatch[1], 10) : null;
        if (width && height) {
          const cleaned = iframeTagContent.replace(/\swidth="[^"]*"|\sheight="[^"]*"/g, '');
          const style = ` style="aspect-ratio: ${width} / ${height}; width: 100%; height: auto;"`;
          return `<iframe${cleaned}${style}>`;
        }
        return match;
      })
      .replace(/CODE_BLOCK_PLACEHOLDER/g, () => {
        return codeBlocks.shift() || '';
      });
  }, [value]);

export default usePrepareHtml;
